<template>
    <div class="client-selection-list">
        <h4>Clientes Asignados</h4>
        <div
            class="row"
            v-for="assignation in assignations"
            :key="assignation.id"
        >
            <div
                class="col"
                v-if="assignation.structure.structure_type.slug != 'ronda'"
            >
                <button
                    class="btn btn-confirm btn-block"
                    @click="setClient(assignation)"
                >
                    {{ assignation.structure.client.name }} ({{
                        assignation.structure.name
                    }})
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import shiftRepository from '../../../../repositories/shifts.repository.js'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as actions from '../../../../store/actionTypes'

export default {
    computed: {
        ...mapGetters(['assignedClients']),
        assignations() {
            return this.assignedClients.filter(
                item => !!item.structure && !item.structure.client.deleted_at
            )
        },
    },
    methods: {
        ...mapMutations({
            setClient: 'client',
            setAccessPoint: 'accessPoint',
        }),
        ...mapActions({
            loadEntries: 'entries',
        }),
        setClient(assignation) {
            const client = assignation.structure.client
            const accessPoint = assignation.structure
            this.$store.commit('client', client)
            this.$store.commit('accessPoint', accessPoint)
            // this.$store.dispatch('entries', client.id)
            // this.$store.dispatch('loadPendingMail')
            this.$store.dispatch(actions.LOAD_RESTRICTED_VISITORS, client.id)

            if (this.user.profile.slug === 'escolta') {
                this.$router.push({ name: this.user.profile.default_screen })
            } else {
                // Validar si hay un turno iniciado para continuar con la vigilancia
                const sr = Object.assign({}, shiftRepository)
                sr.validateOpenShift(assignation.structure.id, this.user.id)
                    .then(data => {
                        if (data.status) {
                            toastr.success(
                                'Existe un turno que no se ha cerrado, continuará en este turno'
                            )
                            this.$store.commit('shift', data.shift)
                            this.$router.push({
                                name: this.user.profile.default_screen,
                            })
                        } else {
                            this.$router.push({ name: 'shiftStartPage' })
                        }
                    })
                    .catch(error => {
                        toastr.error('Ocurrio un error al validar el turno')
                    })
            }
        },
    },
}
</script>
